// PageSync - WebSocket-based real-time sync
import { flash, i18nFlash } from './flash.js'

const PageSync = {
  subscriptions: {},
  callbacks: {},
  adapter: null,
  logging: false,

  log(...args) {
    return this.logging && window.console && console.log &&
      Function.apply.call(console.log, console, args)
  },

  flash(resource) {
    if (resource.i18n) {
      i18nFlash(resource.message, resource.severity, resource.timeout, resource.tag, resource.data)
    } else {
      flash(resource.message, resource.severity, resource.timeout, resource.tag)
    }
  },

  dispatch(action, resource, path) {
    this.log(`page-sync: ${action} ${JSON.stringify(resource)}`)
    if (action === 'flash') {
      this.flash(resource)
    } else if (this.callbacks[path]) {
      this.callbacks[path](action, resource, path)
    }
  },

  subscribe(path, persistent) {
    if (this.unregistered(path) || this.subscribed(path) || this.persistent(path)) return
    this.subscriptions[path] = persistent ? null : true
    this.adapter.subscribe(path, (messages) => {
      messages.forEach(({ action, resource }) => {
        PageSync.dispatch(action, resource, path)
      })
    })
    this.log(`page-sync: subscribed to ${path} using ${this.adapter.name}${persistent ? ' (persistent)' : ''}`)
  },

  unsubscribe(path) {
    if (this.unregistered(path) || this.unsubscribed(path)) return
    this.subscriptions[path] = false
    this.adapter.unsubscribe(path)
    this.log(`page-sync: unsubscribed from ${path} using ${this.adapter.name}`)
  },

  register(path, persistent, callback) {
    if (this.unregistered(path)) {
      this.subscriptions[path] = false
      this.log(`page-sync: registered for ${path}`)
      this.callbacks[path] = callback
      this.subscribe(path, persistent)
    } else if (this.unsubscribed(path)) {
      this.callbacks[path] = callback
      this.subscribe(path, persistent)
    } else if (this.subscribed(path)) {
      this.callbacks[path] = callback
    }
  },

  unregister(path) {
    if (this.registered(path)) {
      this.unsubscribe(path)
      delete this.subscriptions[path]
      delete this.callbacks[path]
      this.log(`page-sync: unregistered from ${path}`)
    }
  },

  cleanup(persistent) {
    const currentPath = document.location.pathname
    Object.keys(this.subscriptions).forEach((path) => {
      const state = this.subscriptions[path]
      if (state === true && path !== currentPath || persistent && state === null) {
        this.unsubscribe(path)
      }
    })
  },

  registered(path) {
    return this.subscriptions[path] !== undefined
  },

  unregistered(path) {
    return this.subscriptions[path] === undefined
  },

  subscribed(path) {
    return this.subscriptions[path] === true
  },

  unsubscribed(path) {
    return this.subscriptions[path] === false
  },

  persistent(path) {
    return this.subscriptions[path] === null
  },

  init(adapter, url) {
    this.adapter = adapter
    this.adapter.init(url)
    return this.adapter.endpoint
  }
}

export default PageSync
